
  import EventBus from '@/events/EventBus';
  import Events from '@/events/Events';

  export default {
    name: 'SectionJobDetails',
    components: {
      JobDetailsActive: () => import('@/components/JobDetailsActive'),
      JobDetailsInactive: () => import('@/components/JobDetailsInactive'),
    },
    props: {
      section: {
        type: Object,
        required: true,
        default: () => {},
      },
    },
    data() {
      return {
        jobPosting: {},
        teaseredArticles: [],
      };
    },
    async fetch() {
      this.jobPosting = this.section.jobPosting;
    },
    mounted() {
      this.$emitWithClientData(Events.JobDetailsViewed, {
        jobPostingId: this.jobPosting.id,
        isPublished: this.$showJobAsPublished(this.jobPosting.is_published),
      });
    },
    created() {
      if (process.client) {
        EventBus.$on('login', this.refetchJobPosting);
        EventBus.$on('logout', this.fetchJobPostings);

        EventBus.$on('applied-on-job', this.refetchJobPosting);
        EventBus.$on('favored-job', this.refetchJobPosting);
        EventBus.$on('unfavored-job', this.refetchJobPosting);
      }
    },
    destroyed() {
      if (process.client) {
        EventBus.$off('login', this.refetchJobPosting);
        EventBus.$off('logout', this.fetchJobPostings);

        EventBus.$off('applied-on-job', this.refetchJobPosting);
        EventBus.$off('favored-job', this.refetchJobPosting);
        EventBus.$off('unfavored-job', this.refetchJobPosting);
      }
    },
    methods: {
      async refetchJobPosting() {
        this.jobPosting = await this.$store.dispatch(
          'api/jobPosting/getJobPosting',
          this.jobPosting.id
        );
      },
    },
  };
